import { useState } from "react";

/**
 * Componente seguro para mostrar imágenes (comprobantes, fotos, etc.) con fallback.
 * Evita XSS al no usar innerHTML/outerHTML/dangerouslySetInnerHTML.
 *
 * Props:
 *  - src: URL de la imagen
 *  - alt: texto alternativo
 *  - className: clases del <img>
 *  - fallback: ReactNode opcional a renderizar si la imagen falla (default: ícono 📎)
 *  - fallbackClassName: clases del contenedor de fallback (default: caja gris con texto)
 */
const ImgFallback = ({ src, alt = "imagen", className = "", fallback = null, fallbackClassName = "" }) => {
  const [errored, setErrored] = useState(false);
  if (errored || !src) {
    if (fallback !== null) return fallback;
    return (
      <div className={fallbackClassName || "w-full h-full flex flex-col items-center justify-center text-[10px] text-amber-700 bg-amber-50 text-center p-1"}>
        <span>📎</span>
        <span>ver</span>
      </div>
    );
  }
  return <img src={src} alt={alt} className={className} onError={() => setErrored(true)} />;
};

export default ImgFallback;
